import { TransportationTypeIcon } from '@/components/icons/TransportationTypeIcon';
import type { LegDTO } from '@/types/dto/agent';
import { Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface LegOriginDestinationProps {
  origin: string;
  destination: string;
  ptMode?: LegDTO['ptMode'];
}

const LegOriginDestination: FC<LegOriginDestinationProps> = ({
  origin,
  destination,
  ptMode,
}) => {
  return (
    <div className="flex flex-row gap-2">
      <div className="flex w-fit flex-col">
        <TransportationTypeIcon
          ptMode={ptMode}
          className="mx-auto text-primary"
        />
        <div className="mx-auto h-full w-0.5 bg-neutral-light" />
        <Icons.destination
          height={12}
          width={12}
          className="mx-auto text-primary"
        />
      </div>
      <div className="flex w-full flex-col gap-2">
        <div className="flex flex-row justify-between">
          <Typography variant="body2-bold">{origin}</Typography>
        </div>
        <div className="flex flex-row justify-between">
          <Typography variant="body2-bold">{destination}</Typography>
        </div>
      </div>
    </div>
  );
};

export default LegOriginDestination;
